



export function genericSearch() {

    let paginationLinks = document.querySelectorAll("[data-page]");

    paginationLinks.forEach(el => el.addEventListener("click", () => changePage(el.getAttribute("data-page"))));

    function changePage(n) {
        window.location.href = updateQueryStringParameter(window.location.href, 'p', n);
    };

    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }
}